import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

const getIcon = (bidenNum, trumpNum, status) => {
    if (status !== '已结束') return '';

    let styleName = '';

    if (bidenNum > trumpNum) {
        styleName = styles.biden_icon;
    }

    if (trumpNum > bidenNum) {
        styleName = styles.trump_icon;
    }

    return styleName;
};

class DataList extends React.PureComponent {
    static propTypes = {
        data: PropTypes.array,
        main: PropTypes.array,
    };

    state = {
        current: null,
        data: [...this.props.data.slice(1)],
    };

    componentDidMount () {
        this.handleTabsChange(0);
    }

    componentDidUpdate(prevProps) {
        const { current } = this.state;
        const { data, main } = this.props;

        const { _bidenNum, _trumpNum, _otherNum, _bidenSum, _trumpSum, _otherSum } = data[0];

        if (
            _bidenNum !== prevProps.data[0]._bidenNum ||
            _trumpNum !== prevProps.data[0]._trumpNum ||
            _otherNum !== prevProps.data[0]._otherNum ||
            _bidenSum !== prevProps.data[0]._bidenSum ||
            _trumpSum !== prevProps.data[0]._trumpSum ||
            _otherSum !== prevProps.data[0]._otherSum
        ) {
            let newData = [...data.slice(1)];

            if (current === 0) {
                newData = [...data.slice(1).filter(item => main.indexOf(item.name) > -1)];
            } else if (current === 1) {
                newData = [...data.slice(1)]
                    .filter(item => item.bidenRate > 0)
                    .sort((a, b) => {
                        return b.bidenRate - a.bidenRate;
                    })
                    .concat([...data.slice(1)].filter(item => item.bidenRate === 0));
            } else if (current === 2) {
                newData = [...data.slice(1)]
                    .filter(item => item.trumpRate > 0)
                    .sort((a, b) => {
                        return b.trumpRate - a.trumpRate;
                    })
                    .concat([...data.slice(1)].filter(item => item.trumpRate === 0));
            }

            this.setState({
                data: [...newData],
            });
        }
    }

    handleTabsChange = index => {
        const { current } = this.state;

        const { data, main } = this.props;

        let newData = [];

        if (index === current) {
            this.setState({
                current: null,
                data: [...data.slice(1)],
            });
        } else {
            if (index === 0) {
                newData = [...data.slice(1).filter(item => main.indexOf(item.name) > -1)];
            } else if (index === 1) {
                newData = [...data.slice(1)]
                    .filter(item => item.bidenRate > 0)
                    .sort((a, b) => {
                        return b.bidenRate - a.bidenRate;
                    })
                    .concat([...data.slice(1)].filter(item => item.bidenRate === 0));
            } else if (index === 2) {
                newData = [...data.slice(1)]
                    .filter(item => item.trumpRate > 0)
                    .sort((a, b) => {
                        return b.trumpRate - a.trumpRate;
                    })
                    .concat([...data.slice(1)].filter(item => item.trumpRate === 0));
            }

            this.setState({
                current: index,
                data: [...newData],
            });
        }
    };

    render() {
        const { current, data } = this.state;

        return (
            <div className={styles.data_box}>
                <div className={styles.title}>
                    <span>各州选情</span>
                    <div className={styles.bar_box}>
                        <span />
                        <span>特朗普</span>
                        <span />
                        <span>哈里斯</span>
                        <span />
                        <span>其他</span>
                    </div>
                </div>
                <div className={styles.tabs}>
                    <span
                        className={`${styles.tab} ${current === 0 ? styles.default_tab : ''}`}
                        onClick={() => this.handleTabsChange(0)}>
                        仅看关键州
                    </span>
                    <span
                        className={`${styles.tab} ${current === 2 ? styles.trump_tab : ''}`}
                        onClick={() => this.handleTabsChange(2)}>
                        特朗普得票率
                    </span>
                    <span
                        className={`${styles.tab} ${current === 1 ? styles.biden_tab : ''}`}
                        onClick={() => this.handleTabsChange(1)}>
                        哈里斯得票率
                    </span>
                </div>
                <div className={styles.list_box}>
                    <div className={styles.list}>
                        <div className={styles.th}>
                            <span>州名</span>
                            <span>选举人票</span>
                            <span>状态</span>
                            <span>得票率</span>
                        </div>
                        {data.map(item => (
                            <div key={item.id} className={styles.tr}>
                                <span>
                                    <span className={getIcon(item.bidenNum, item.trumpNum, item.status)} />
                                    <span>{`${item.name}-${item.id}`}</span>
                                </span>
                                <span>{item.voteSum}</span>
                                <span>{item.status}</span>
                                <span className={styles.rate}>
                                    <span>{item.trumpRate}%</span>
                                    <span>
                                        <span style={{ width: `${item.trumpRate}%` }} />
                                        <span style={{ width: `${item.bidenRate}%` }} />
                                    </span>
                                    <span>{item.bidenRate}%</span>
                                </span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }
}

export default errorBoundary(DataList);
